// extracted by mini-css-extract-plugin
export default {"fontFamily":"TreatmentTable_fontFamily__nBFaU","tableBg":"TreatmentTable_tableBg__aNE6R"};